import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const faqs = [
  {
    question: 'What qualifications do I need to start?',
    answer:
      'No prior qualifications are required for our basic certificate programs. However, for advanced and professional certificates, a basic understanding of business or related field is recommended.',
  },
  {
    question: 'How long are the courses?',
    answer:
      'Programs range from the 8-week Basic Certificate up to the 12-month Mini MBA in International Trade. Diploma and Advanced Diploma programs sit between 6 and 8 months.',
  },
  {
    question: 'Are the certificates internationally recognized?',
    answer:
      'Yes, our certificates are recognized by international trade organizations and meet global standards for export management education.',
  },
  {
    question: 'Can I study while working?',
    answer:
      'Yes, our programs are designed to accommodate working professionals with flexible schedules and online learning options.',
  },
  {
    question: 'What payment options are available?',
    answer:
      'We offer various payment plans including full payment, installment options, and special corporate rates. Contact our admissions team for details.',
  },
];

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-blue-50 border border-blue-200 text-blue-700 text-sm font-medium mb-5">
            FAQ
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900">
            Answers before you enroll
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => {
            const open = openIndex === index;
            return (
              <div
                key={index}
                className={`rounded-xl border transition-colors ${open ? 'border-blue-300 bg-blue-50/40' : 'border-gray-200 bg-white'}`}
              >
                <button
                  className="w-full flex items-center justify-between px-6 py-5 text-left"
                  onClick={() => setOpenIndex(open ? null : index)}
                >
                  <span className="font-semibold text-gray-900">{faq.question}</span>
                  {open ? (
                    <Minus className="h-5 w-5 text-blue-600 flex-shrink-0" />
                  ) : (
                    <Plus className="h-5 w-5 text-blue-600 flex-shrink-0" />
                  )}
                </button>
                {open && (
                  <div className="px-6 pb-5 -mt-1 text-gray-600 leading-relaxed">
                    {faq.answer}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;